import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import DoctoresService from "../services/DoctoresService";
import {
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Paper,
  Typography,
  OutlinedInput,
  Stack,
  Box,
  IconButton,
  Tooltip,
  tooltipClasses,
  Checkbox,
} from "@mui/material";
import Swal from "sweetalert2";
import { mostrarToast } from "../utils/toastUtils";
import { tieneMasDe10Digitos } from "../utils/telefonoUtils";

const Doctores = () => {
  useEffect(() => {
    document.title = "Doctores";
  }, []);
  function mostrarMensaje(mensaje) {
    mostrarToast(mensaje, "success");
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

  async function mostrarBuscarDoctor() {
    let doctoresOriginal = [];
    let doctoresActivos = [];

    const ordenarDoctoresRecientes = (lista) => {
      if (!Array.isArray(lista)) return [];
      return [...lista].sort(
        (a, b) => Number(b.idDoctor || b.id || 0) - Number(a.idDoctor || a.id || 0),
      );
    };

    const resultado = await DoctoresService.getDoctores();
    doctoresOriginal = ordenarDoctoresRecientes(resultado?.data?.doctores || resultado?.doctores || []);
    doctoresActivos = [...doctoresOriginal];

    const porPagina = 8;
    let paginaActual = 1;

    const construirFilas = (lista) => {
      return lista
        .map(
          (doc, idx) => `
      <tr style="background-color: ${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}; border-bottom: 1px solid #e2e8f0; font-size: 0.80rem; transition: background 0.15s;">
        <td style="padding: 6px 10px; text-align: center; font-weight: 600; color: #1e293b; border-right: 1px solid #f1f5f9;">${doc.idDoctor}</td>
        <td style="padding: 6px 12px; text-align: left; font-weight: 500; color: #1e293b; border-right: 1px solid #f1f5f9;">${doc.nombre} ${doc.apPaterno} ${doc.apMaterno}</td>
        <td style="padding: 6px 10px; text-align: left; color: #475569; border-right: 1px solid #f1f5f9;">${doc.nombreRegistro || ""} ${doc.apPaternoRegistro || ""} ${doc.apMaternoRegistro || ""}</td>
        <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
          <button data-action="mostrar" data-iddoctor="${doc.idDoctor}" title="Mostrar" style="background: #e0f2fe; color: #0284c7; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
            <i class="fas fa-eye"></i>
          </button>
        </td>
        <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
          <button data-action="editar" data-iddoctor="${doc.idDoctor}" title="Editar" style="background: #fef3c7; color: #d97706; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
            <i class="fas fa-edit"></i>
          </button>
        </td>
        <td style="padding: 4px 6px; text-align: center;">
          <button data-action="eliminar" data-iddoctor="${doc.idDoctor}" title="Eliminar" style="background: #fee2e2; color: #dc2626; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
    `,
        )
        .join("");
    };

    const renderPagina = (pagina) => {
      const inicio = (pagina - 1) * porPagina;
      const fin = inicio + porPagina;
      const paginaDoctores = doctoresActivos.slice(inicio, fin);
      const tabla = document.getElementById("tablaDoctores");
      if (tabla) {
        if (!paginaDoctores || paginaDoctores.length === 0) {
          tabla.innerHTML = `<tr><td colspan="6" style="padding: 24px; text-align: center; color: #64748b; font-style: italic;">No hay registros</td></tr>`;
        } else {
          tabla.innerHTML = construirFilas(paginaDoctores);
        }
        tabla
          .querySelectorAll("button[data-action='mostrar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.iddoctor;
              const doctor = doctoresOriginal.find(
                (item) => String(item.idDoctor) === String(id),
              );
              if (doctor) {
                verDoctor(doctor);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='editar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.iddoctor;
              const doctor = doctoresOriginal.find(
                (item) => String(item.idDoctor) === String(id),
              );
              if (doctor) {
                editarDoctor(doctor);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='eliminar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.iddoctor;
              const doctor = doctoresOriginal.find(
                (item) => String(item.idDoctor) === String(id),
              );
              if (doctor) {
                Swal.fire({
                  title: "¿Eliminar doctor?",
                  text: `¿Desea eliminar al doctor ${doctor.nombre} ${doctor.apPaterno}?`,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Sí, eliminar",
                  cancelButtonText: "Cancelar",
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    await eliminarDoctor(doctor.idDoctor);
                  }
                });
              }
            });
          });
      }

      const totalPaginas = Math.max(
        1,
        Math.ceil(doctoresActivos.length / porPagina),
      );
      const spanPagina = document.getElementById("paginaActual");
      if (spanPagina) {
        spanPagina.textContent = `Página ${pagina} de ${totalPaginas} (${doctoresActivos.length} registros)`;
      }
      const btnAnterior = document.getElementById("btnAnterior");
      const btnSiguiente = document.getElementById("btnSiguiente");
      if (btnAnterior) {
        btnAnterior.disabled = pagina <= 1;
        btnAnterior.style.opacity = pagina <= 1 ? "0.45" : "1";
        btnAnterior.style.cursor = pagina <= 1 ? "not-allowed" : "pointer";
      }
      if (btnSiguiente) {
        btnSiguiente.disabled = pagina >= totalPaginas;
        btnSiguiente.style.opacity = pagina >= totalPaginas ? "0.45" : "1";
        btnSiguiente.style.cursor = pagina >= totalPaginas ? "not-allowed" : "pointer";
      }
    };
    Swal.fire({
      title: "BUSCAR DOCTOR",
      width: "65%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
      },
      html: `
      <div style="font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; text-align: left;">
        <div style="display: flex; gap: 10px; align-items: flex-end; justify-content: space-between; flex-wrap: wrap; margin-bottom: 8px;">
          <div style="display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 220px;">
            <label style="font-size: 0.80rem; font-weight: 600; color: #334155;">Nombre o código del doctor:</label>
            <input id="buscarDoctor" type="text" style="padding: 5px 10px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.82rem; outline: none; height: 32px; box-sizing: border-box;" placeholder="Escribe aquí...">
          </div>
          <div>
            <button id="btnMostrarTodos" style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; border: none; border-radius: 6px; font-weight: 600; font-size: 0.80rem; padding: 6px 14px; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.1); height: 32px; white-space: nowrap; transition: opacity 0.2s;">
              Mostrar todos los doctores
            </button>
          </div>
        </div>

        <div style="width: 100%; overflow: auto; max-height: 52vh; border: 1px solid #cbd5e1; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.08); background: white;">
          <table class="tablaDoctores" style="width: 100%; border-collapse: collapse; text-align: center;">
            <thead>
              <tr style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; font-size: 0.80rem; position: sticky; top: 0; z-index: 2;">
                <th style="padding: 7px 10px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Código</th>
                <th style="padding: 7px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Nombre del doctor</th>
                <th style="padding: 7px 10px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Empleado que insertó</th>
                <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Mostrar</th>
                <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Editar</th>
                <th style="padding: 7px 8px; text-align: center; font-weight: 600; width: 45px;">Eliminar</th>
              </tr>
            </thead>
            <tbody id="tablaDoctores">
            </tbody>
          </table>
        </div>

        <div style="margin-top: 8px; display: flex; justify-content: space-between; align-items: center;">
          <span id="paginaActual" style="font-size: 0.80rem; color: #64748b; font-weight: 500;"></span>
          <div style="display: flex; gap: 6px;">
            <button id="btnAnterior" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Anterior</button>
            <button id="btnSiguiente" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Siguiente</button>
          </div>
        </div>
      </div>
    `,
      showConfirmButton: false,
      didOpen: () => {
        renderPagina(paginaActual);

        document.getElementById("btnAnterior").addEventListener("click", () => {
          if (paginaActual > 1) {
            paginaActual--;
            renderPagina(paginaActual);
          }
        });

        document
          .getElementById("btnSiguiente")
          .addEventListener("click", () => {
            if (paginaActual < Math.ceil(doctoresActivos.length / porPagina)) {
              paginaActual++;
              renderPagina(paginaActual);
            }
          });

        document
          .getElementById("btnMostrarTodos")
          .addEventListener("click", async () => {
            try {
              const resultado = await DoctoresService.getDoctores();
              doctoresOriginal = ordenarDoctoresRecientes(resultado?.data?.doctores || resultado?.doctores || []);
              doctoresActivos = [...doctoresOriginal];
              paginaActual = 1;
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error al recargar doctores:", error);
            }
            document.getElementById("buscarDoctor").value = "";
          });
        document
          .getElementById("buscarDoctor")
          .addEventListener("input", async (e) => {
            const valor = e.target.value.trim();
            paginaActual = 1;
            if (valor === "") {
              doctoresActivos = [...doctoresOriginal];
              renderPagina(paginaActual);
              return;
            }

            try {
              const resultado = await DoctoresService.buscarDoctores(valor);
              doctoresActivos = ordenarDoctoresRecientes(resultado?.doctores || resultado?.data?.doctores || []);
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error en búsqueda:", error);
            }
          });
      },
    });
  }

  const verDoctor = (doctor) => {
    setEspecialidad(doctor.especialidad || "");
    setNombre(doctor.nombre || "");
    setApPaterno(doctor.apPaterno || "");
    setApMaterno(doctor.apMaterno || "");
    setSexo(doctor.sexo || "");
    setEsComision(Boolean(doctor.esComision || doctor.conComision || doctor.comision));
    setEdoCivil(doctor.eCivil || "seleccione");
    setFechaNac(doctor.fechaNacimiento || "");
    setEmail(doctor.email || "");
    setTelefonoTrabajo(doctor.telefonoTrabajo || "");
    setTelefonoCel(doctor.telefonoCelular || doctor.telefonoCel || "");
    setInstitucion(doctor.institucion || "");
    setHorario(doctor.horario || "");
    setCalle(doctor.calle || "");
    setColonia(doctor.colonia || "");
    setCPostal(doctor.cPostal || "");
    setCiudad(doctor.ciudad || "");
    setReferencia(doctor.referencia || "");
    setObservaciones(doctor.observaciones || "");
    setUsuario(doctor.usuario || doctor.usuarioN || "");
    setContrasena(doctor.contrasenia || doctor.contrasena || "");
    setSelectedDoctorId(null);
    setEditMode(false);
    setViewOnly(true);
  };

  const editarDoctor = (doctor) => {
    setEspecialidad(doctor.especialidad || "");
    setNombre(doctor.nombre || "");
    setApPaterno(doctor.apPaterno || "");
    setApMaterno(doctor.apMaterno || "");
    setSexo(doctor.sexo || "");
    setEsComision(Boolean(doctor.esComision || doctor.conComision || doctor.comision));
    setEdoCivil(doctor.eCivil || "seleccione");
    setFechaNac(doctor.fechaNacimiento || "");
    setEmail(doctor.email || "");
    setTelefonoTrabajo(doctor.telefonoTrabajo || "");
    setTelefonoCel(doctor.telefonoCelular || "");
    setInstitucion(doctor.institucion || "");
    setHorario(doctor.horario || "");
    setCalle(doctor.calle || "");
    setColonia(doctor.colonia || "");
    setCPostal(doctor.cPostal || "");
    setContrasena(doctor.contrasenia || doctor.contrasena || "");
    setSelectedDoctorId(doctor.idDoctor);
    setEditMode(true);
    setViewOnly(false);
  };

  function reloadPage() {
    window.location.reload();
  }

  const [especialidad, setEspecialidad] = useState("");
  const [nombre, setNombre] = useState("");
  const [apPaterno, setApPaterno] = useState("");
  const [apMaterno, setApMaterno] = useState("");
  const [sexo, setSexo] = useState("");
  const [esComision, setEsComision] = useState(false);
  const [errorNombre, setErrorNombre] = useState(false);
  const [errorApPaterno, setErrorApPaterno] = useState(false);
  const [edoCivil, setEdoCivil] = useState("seleccione");
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [fechaNac, setFechaNac] = useState("");
  const [email, setEmail] = useState("");
  const [telefonoTrabajo, setTelefonoTrabajo] = useState("");
  const [telefonoCel, setTelefonoCel] = useState("");
  const [institucion, setInstitucion] = useState("");
  const [horario, setHorario] = useState("");
  const [calle, setCalle] = useState("");
  const [colonia, setColonia] = useState("");
  const [cPostal, setCPostal] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [referencia, setReferencia] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [usuario, setUsuario] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [viewOnly, setViewOnly] = useState(false);

  const usuarioString = sessionStorage.getItem("usuario");
  const currentU = JSON.parse(usuarioString);

  const registrarDoc = async () => {
    if (nombre === "" && apPaterno === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorNombre(true);
      setErrorApPaterno(true);
    } else if (nombre === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorNombre(true);
    } else if (apPaterno === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorApPaterno(true);
    } else if (tieneMasDe10Digitos(telefonoTrabajo)) {
      mostrarError("El teléfono de trabajo no puede tener más de 10 dígitos.");
    } else if (tieneMasDe10Digitos(telefonoCel)) {
      mostrarError("El teléfono celular no puede tener más de 10 dígitos.");
    } else {
      let doctor = {
        especialidad: especialidad,
        eCivil: edoCivil,
        institucion: institucion,
        horario: horario,
        referencia: referencia,
        observaciones: observaciones,
        nombre: nombre,
        apPaterno: apPaterno,
        apMaterno: apMaterno,
        sexo: sexo,
        calle: calle,
        colonia: colonia,
        cPostal: cPostal,
        ciudad: ciudad,
        fechaNacimiento: fechaNac,
        telefonoTrabajo: telefonoTrabajo,
        telefonoCelular: telefonoCel,
        email: email,
        usuarioN: usuario,
        contrasenia: contrasena,
        esComision: esComision,
        conComision: esComision,
        estatus: "A",
        rol: "M",
        registro: currentU.id,
      };
      let doctorUpd = {
        especialidadN: especialidad,
        eCivilN: edoCivil,
        institucionN: institucion,
        horarioN: horario,
        referenciaN: referencia,
        observacionesN: observaciones,
        nombreN: nombre,
        apPaternoN: apPaterno,
        apMaternoN: apMaterno,
        sexoN: sexo,
        esComisionN: esComision,
        conComisionN: esComision,
        calleN: calle,
        coloniaN: colonia,
        cPostalN: cPostal,
        ciudadN: ciudad,
        fechaNacimientoN: fechaNac,
        telefonoTrabajoN: telefonoTrabajo,
        telefonoCelularN: telefonoCel,
        emailN: email,
        usuarioN: usuario,
        contraseniaN: contrasena,
      };

      try {
        let resultado;
        if (editMode && selectedDoctorId) {
          resultado = await DoctoresService.updateDoctor(
            doctorUpd,
            selectedDoctorId,
          );
        } else {
          resultado = await DoctoresService.agregarDoctor(doctor);
        }
        if (resultado.data.estatus === "OK") {
          mostrarMensaje(
            editMode
              ? "Doctor actualizado con éxito!"
              : "Doctor agregado con exito!",
          );
        } else {
          mostrarError(
            editMode
              ? "No se pudo actualizar el doctor: " + resultado.data.mensaje
              : "No se pudo agregar el doctor: " + resultado.data.mensaje,
          );
        }
      } catch (error) {
        mostrarError(
          editMode ? "Error al actualizar doctor:" : "Error al agregar doctor:",
          error,
        );
      }
    }
  };
  const eliminarDoctor = async (doctorId) => {
    try {
      const resultado = await DoctoresService.deleteDoctor(doctorId);
      if (resultado.data.estatus === "OK") {
        mostrarMensaje("Doctor eliminado con éxito!");
      } else {
        mostrarError("Error al eliminar doctor");
      }
    } catch (error) {
      console.error("Error al eliminar doctor:", error);
      mostrarError("Error al eliminar doctor");
    }
  };

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            paddingTop: "2vh",
            paddingBottom: "2vh",
          }}
        >
          <Stack spacing={2} sx={{ width: "95vw", maxWidth: "96vw" }}>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperDoc"
            >
              <Typography
                variant="h7"
                fontWeight="bold"
                gutterBottom
                sx={{
                  background: "linear-gradient(90deg, #006787, #014e65)",
                  color: "white",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  display: "inline-block",
                  fontWeight: "bold",
                }}
              >
                DATOS PRINCIPALES
              </Typography>

              {/* Contenedor principal */}
              <Grid container spacing={"0.3vw"}>
                <Grid
                  item
                  xs={12}
                  container
                  spacing={"1vw"}
                  sx={{ paddingTop: "0.4vw" }}
                >
                  <Stack direction="row" spacing={"3vw"}>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfEspecialidad"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Especialidad:
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={especialidad}
                        disabled={viewOnly}
                        onChange={(e) => {
                          setEspecialidad(e.target.value);
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "13vw"
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfEspecialidad"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfNombre"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Nombre:<span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={nombre}
                        disabled={viewOnly}
                        onChange={(e) => {
                          setNombre(e.target.value);
                          if (errorNombre && e.target.value.trim() !== "") {
                            setErrorNombre(false);
                          }
                        }}
                        error={errorNombre}
                        helperText={errorNombre ? "Nombre obligatorio" : ""}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "13vw"
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfNombre"
                        required
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfApPaterno"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Apellido Paterno:{" "}
                        <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={apPaterno}
                        disabled={viewOnly}
                        onChange={(e) => {
                          setApPaterno(e.target.value);
                          if (errorApPaterno && e.target.value.trim() !== "") {
                            setErrorApPaterno(false);
                          }
                        }}
                        error={errorApPaterno}
                        helperText={
                          errorApPaterno ? "Apellido paterno obligatorio" : ""
                        }
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "13vw"
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfApPaterno"
                        required
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfApMaterno"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Apellido Materno:
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={apMaterno}
                        disabled={viewOnly}
                        onChange={(e) => {
                          setApMaterno(e.target.value);
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "13vw"
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfApMaterno"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <FormControl>
                        <FormLabel
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Sexo:
                        </FormLabel>
                        <RadioGroup
                          row
                          value={sexo}
                          onChange={(e) => {
                            setSexo(e.target.value);
                          }}
                          disabled={viewOnly}
                        >
                          <FormControlLabel
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontSize: "1vw",
                                fontWeight: "bold",
                              },
                            }}
                            value="M"
                            control={
                              <Radio
                                disabled={viewOnly}
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    height: "1vw",
                                    width: "1vw",
                                  },
                                }}
                              />
                            }
                            label="Masculino"
                          />
                          <FormControlLabel
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontSize: "1vw",
                                fontWeight: "bold",
                              },
                            }}
                            value="F"
                            control={
                              <Radio
                                disabled={viewOnly}
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    height: "1vw",
                                    width: "1vw",
                                  },
                                }}
                              />
                            }
                            label="Femenino"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Stack>
                  {/* Sexo y estado civil */}

                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"1vw"}
                    sx={{ paddingTop: "0.4vw" }}
                  >
                    <Stack direction="row" spacing={"3vw"}>
                      <Grid item xs={2}>
                        <InputLabel
                          htmlFor="selectEstadoCivil"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Estado Civil:
                        </InputLabel>
                        <Select
                          input={<OutlinedInput />}
                          value={edoCivil}
                          disabled={viewOnly}
                          onChange={(e) => {
                            setEdoCivil(e.target.value);
                          }}
                          sx={{
                            width: "13vw",
                            maxWidth: "100%",
                            height: "5vh",
                            minHeight: "0px !important",
                            overflow: "hidden",

                            "&.MuiInputBase-root": {
                              minHeight: "0px !important",
                            },

                            "& .MuiSelect-select": {
                              minHeight: "0px !important",
                              padding: "0 0.5vw !important",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "1vw",
                              lineHeight: "1",
                            },

                            "& .MuiOutlinedInput-notchedOutline": {
                              top: 0,
                              "& legend": { display: "none" },
                            },

                            "& .MuiSvgIcon-root": {
                              display: "inline-block !important",
                              position: "absolute",
                              right: "0.5vw",
                              top: "50%",
                              transform: "translateY(-50%)",
                              fontSize: "1.2vw !important",
                              width: "1.2vw !important",
                              height: "1.2vw !important",
                              pointerEvents: "none",
                            },
                            minWidth: "0px !important",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          }}
                          className="selectEstadoCivil"
                        >
                          <MenuItem
                            sx={{
                              fontSize: "1vw",
                              padding: "0.5vw",
                            }}
                            value="seleccione"
                            disabled
                          >
                            Seleccione
                          </MenuItem>
                          <MenuItem
                            sx={{
                              fontSize: "1vw",
                              padding: "0.5vw",
                            }}
                            value="soltero"
                          >
                            Soltero(a)
                          </MenuItem>
                          <MenuItem
                            sx={{
                              fontSize: "1vw",
                              padding: "0.5vw",
                            }}
                            value="casado"
                          >
                            Casado(a)
                          </MenuItem>
                          <MenuItem
                            sx={{
                              fontSize: "1vw",
                              padding: "0.5vw",
                            }}
                            value="viudo"
                          >
                            Viudo(a)
                          </MenuItem>
                          <MenuItem
                            sx={{
                              fontSize: "1vw",
                              padding: "0.5vw",
                            }}
                            value="divorciado"
                          >
                            Divorciado(a)
                          </MenuItem>
                          <MenuItem
                            sx={{
                              fontSize: "1vw",
                              padding: "0.5vw",
                            }}
                            value="amasiato"
                          >
                            Amasiato(Union libre)
                          </MenuItem>
                          <MenuItem
                            sx={{
                              fontSize: "1vw",
                              padding: "0.5vw",
                            }}
                            value="separado"
                          >
                            Separado(a)
                          </MenuItem>
                          <MenuItem
                            sx={{
                              fontSize: "1vw",
                              padding: "0.5vw",
                            }}
                            value="otro"
                          >
                            Otro
                          </MenuItem>
                        </Select>
                      </Grid>

                      {/* Fecha de nacimiento */}
                      <Grid item xs={2}>
                        <InputLabel
                          htmlFor="txfFechaNacimiento"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Fecha de Nacimiento:
                        </InputLabel>
                        <TextField
                          fullWidth
                          value={fechaNac}
                          disabled={viewOnly}
                          onChange={(e) => {
                            setFechaNac(e.target.value);
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "13vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfFechaNacimiento"
                          type="date"
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      {/* Email y teléfonos */}
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfEmail"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Email:
                        </InputLabel>
                        <TextField
                          fullWidth
                          value={email}
                          disabled={viewOnly}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "13vw"
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfEmail"
                          type="email"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfTelefonoTrabajo"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Teléfono (Trabajo):
                        </InputLabel>
                        <TextField
                          fullWidth
                          value={telefonoTrabajo}
                          disabled={viewOnly}
                          error={tieneMasDe10Digitos(telefonoTrabajo)}
                          helperText={tieneMasDe10Digitos(telefonoTrabajo) ? "Máximo 10 dígitos" : ""}
                          onChange={(e) => {
                            setTelefonoTrabajo(e.target.value);
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "13vw"
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfTelefonoTrabajo"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfTelefonoCelular"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Teléfono (Celular):
                        </InputLabel>
                        <TextField
                          fullWidth
                          value={telefonoCel}
                          disabled={viewOnly}
                          error={tieneMasDe10Digitos(telefonoCel)}
                          helperText={tieneMasDe10Digitos(telefonoCel) ? "Máximo 10 dígitos" : ""}
                          onChange={(e) => {
                            setTelefonoCel(e.target.value);
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "13vw"
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfTelefonoCelular"
                        />
                      </Grid>
                    </Stack>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"1vw"}
                    sx={{ paddingTop: "0.8vw" }}
                  >
                    <Stack direction="row" spacing={"3vw"}>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={esComision}
                              onChange={(e) => setEsComision(e.target.checked)}
                              disabled={viewOnly}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  height: "1.2vw",
                                  width: "1.2vw",
                                },
                              }}
                            />
                          }
                          label="Doctor con comisión"
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "1vw",
                              fontWeight: "bold",
                            },
                          }}
                        />
                      </Grid>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperLugar"
            >
              {/* Lugar de atencion */}
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0vw" }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h7"
                    fontWeight="bold"
                    gutterBottom
                    align="center"
                    sx={{
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      marginTop: "0vw",
                      fontWeight: "bold"
                    }}
                  >
                    LUGAR DE ATENCIÓN
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"2vw"}
                sx={{ paddingTop: "0.4vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfInstitucion"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Institución:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={institucion}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setInstitucion(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                          width: "13vw"
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfInstitucion"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfHorarioAtencion"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Horario de Atención:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={horario}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setHorario(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                          width: "13vw"
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfHorarioAtencion"
                    />
                  </Grid>
                </Stack>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0.4vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={12}>
                    <InputLabel
                      htmlFor="txfCalle"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Calle:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={calle}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setCalle(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                          width: "13vw"
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfCalle"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel
                      htmlFor="txfColonia"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Colonia:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={colonia}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setColonia(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                          width: "13vw"
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfColonia"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel
                      htmlFor="txfCPostal"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Código Postal:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={cPostal}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setCPostal(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                          width: "13vw"
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfCPostal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel
                      htmlFor="txfCiudad"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Ciudad:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={ciudad}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setCiudad(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                          width: "13vw"
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfCiudad"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel
                      htmlFor="txfReferencia"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Referencia:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={referencia}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setReferencia(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                          width: "13vw"
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfReferencia"
                    />
                  </Grid>
                </Stack>
              </Grid>

              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0.4vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={12}>
                    <InputLabel
                      htmlFor="txfObservaciones"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Observaciones:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={observaciones}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setObservaciones(e.target.value);
                      }}
                      multiline
                      rows={4}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "9vh",
                          width: "28.3vw",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                          lineHeight: "0.8vw",
                        },
                      }}
                      className="txfObservaciones"
                    />
                  </Grid>
                </Stack>
              </Grid>
            </Paper>
          </Stack>
        </Box>
        <Box
          sx={{
            position: "fixed",
            right: "6vw",
            top: "30%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {!viewOnly && (
            <Tooltip
              title={"Guardar doctor"}
              arrow
              placement="right"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                    {
                      marginTop: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: "0.2vw",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                    {
                      marginLeft: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                    {
                      marginRight: "0px",
                    },
                  },
                },
                tooltip: {
                  sx: {
                    fontSize: "0.7vw",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    fontFamily: "Roboto-Medium",
                    color: "#000000",
                    marginBottom: "-5px",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(255,255,255,0.9)",
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  width: "4vw",
                  height: "4vw",
                }}
                onClick={registrarDoc}
              >
                <SaveIcon sx={{ fontSize: "1.8vw" }} />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip
            title={"Nuevo doctor"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
              onClick={reloadPage}
            >
              <AddIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
          <Tooltip
            title={"Buscar doctor"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
              onClick={mostrarBuscarDoctor}
            >
              <SearchIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Content>
    </Layout>
  );
};
export default Doctores;
